import { Badge } from "~/components/design-system/components"

/** On a package or folder the draft created or changed: it counts in the bar until published. */
export function NotPublishedBadge({ size }: { size?: "xs" }) {
  return (
    <Badge size={size} variant="yellow">
      Not published
    </Badge>
  )
}
